<template>
  <div>
    <e-dialog
      dialog-title="供应商库添加"
      :center-dialog-visible="addSupplierVisible"
      popup-width="1080px"
      destroy-close
      modal-append-to-body
      @submitPopupData="handleConfirm"
      @resetPopupData="handleCancel"
    >
      <div>
        <e-search
          :data="listQuery"
          :field-list="filterInfo.fieldList"
          @handleFilter="handleSearch"
          @handleReset="handleReset"
        ></e-search>
        <div class="margin-t10">
          <e-table-list
            row-key="id"
            :table-data="tableData"
            :table-label="tableLabel"
            :index-show="true"
            :selection-show="true"
            @handleSelectionChange="handleSelectionChange"
          ></e-table-list>
          <div class="pagination">
            <el-pagination
              background
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="listQuery.pageNum"
              :page-size="listQuery.pageSize"
              :total="pageTotal"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '../../../components/common/e-dialog';
import eSearch from '../../../components/common/e-search';
import eTableList from '../../../components/common/e-table-list';
import api from '../../../api/user';

export default {
  name: 'AddSupplierDialog',
  components: {
    eDialog,
    eSearch,
    eTableList,
  },
  props: {
    addSupplierVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        subCompanyName: '',
      },
      filterInfo: {
        data: {},
        fieldList: [
          { label: '供应商名称', type: 'input', value: 'subCompanyName' },
        ],
      },
      tableData: [],
      tableLabel: [
        { label: '供应商名称', param: 'subCompanyName', align: 'center' },
      ],
      pageTotal: 0,
      selectedRows: [],
    };
  },
  mounted() {
    this.querySupplierList();
  },
  methods: {
    async querySupplierList() {
      const res = await api.querySupplierList(this.listQuery);
      if (res.code === '200') {
        this.tableData = res.data.records || [];
        this.pageTotal = res.data.total || 0;
      }
    },
    handleSearch(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.subCompanyName = val.subCompanyName;
      this.listQuery.pageSize = 10;
      this.querySupplierList();
    },
    handleReset() {
      this.listQuery = {
        pageNum: 1,
        pageSize: 10,
        subCompanyName: '',
      };
      this.querySupplierList();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.querySupplierList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.querySupplierList();
    },
    handleSelectionChange(val) {
      console.log(val);
      this.selectedRows = val;
    },
    async handleConfirm() {
      //       入参改成  {
      //     "idList": [
      //         16,
      //         17
      //     ]
      // }

      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择供应商');
        return;
      }
      let selectedRows = [];
      if (this.selectedRows.length > 0) {
        selectedRows = this.selectedRows.map((item) => item.id);
      }
      console.log(selectedRows);
      const res = await api.batchAddSupplier({ idList: selectedRows });
      if (res.code === '200') {
        this.$message.success('添加成功');
        this.handleReset();
        this.$emit('update:addSupplierVisible', false);
      }
    },
    handleCancel() {
      this.selectedRows = [];
      this.$emit('update:addSupplierVisible', false);
    },
  },
};
</script>
